import { jsx } from "react/jsx-runtime";
import { useTranslation } from "../../../../lib/hooks/useTranslation.js";
import { useSubtitleTrack } from "../../../VideoContextProvider/context/state/subtitleTrack.js";
import { useSubtitlesEnabled, useSetSubtitlesEnabled } from "../../../VideoContextProvider/context/state/subtitles.js";
import { useVideoController } from "../../../VideoContextProvider/context/videoController.js";
import { ClosedCaption } from "./icons/ClosedCaption.js";
const SubtitlesButton = ({ isVOD = false }) => {
  const { t } = useTranslation();
  const videoController = useVideoController();
  const subtitleTrackId = useSubtitleTrack();
  const subtitlesEnabled = useSubtitlesEnabled();
  const setSubtitlesEnabled = useSetSubtitlesEnabled();
  const subtitleBtnClassName = isVOD ? `omega_btnSubtitleVOD` : `omega_btnSubtitle`;
  function disableSubtitles() {
    videoController.disableSubtitles();
    setSubtitlesEnabled(false);
  }
  function enableSubtitles(subtitleTrack) {
    videoController.enableSubtitles(subtitleTrack);
    setSubtitlesEnabled(true);
  }
  return subtitlesEnabled ? /* @__PURE__ */jsx(
    "button",
    {
      type: "button",
      onClick: () => disableSubtitles(),
      "data-test": "disable-subtitles",
      "aria-label": t("Closed captions"),
      "aria-pressed": "true",
      className: subtitleBtnClassName,
      children: /* @__PURE__ */jsx(ClosedCaption, { className: "omega_captionOn" })
    }
  ) : /* @__PURE__ */jsx(
    "button",
    {
      type: "button",
      onClick: () => enableSubtitles(subtitleTrackId),
      "data-test": "enable-subtitles",
      "aria-label": t("Closed captions"),
      "aria-pressed": "false",
      className: subtitleBtnClassName,
      children: /* @__PURE__ */jsx(ClosedCaption, { className: "omega_captionOff" })
    }
  );
};
export {
  SubtitlesButton };
//# sourceMappingURL=dist/components/VideoContainer/VideoControlRack/SubtitlesButton/index.js.map